import { yupResolver } from '@hookform/resolvers/yup'
import { Box, OutlinedInput, Link } from '@mui/material'
import { Auth } from 'aws-amplify'
import { ErrorText, MButton, Text } from 'components'
import { ROUTES_PATH } from 'config'
import { color } from 'config/color'
import { FormLabel } from 'containers/Auth/SignIn/component'
import { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import * as yup from 'yup'

function BackToLogin(): JSX.Element {
  return (
    <Box mt="40px">
      <Link href={ROUTES_PATH.SIGNIN} underline="none">
        <Text color={color.secondary.dark[900]} fontSize="16px" align="center">
          Back to Login
        </Text>
      </Link>
    </Box >
  )
}

const schema = yup
  .object({
    email: yup.string().email().required('Email is required')
  })
  .required()

interface IForgotPwdForm {
  email: string
}

export const Form: React.FC = () => {
  const navigate = useNavigate()
  const {
    handleSubmit,
    control,
    formState: { errors, isValid }
  } = useForm<IForgotPwdForm>({
    mode: 'all',
    defaultValues: {
      email: ''
    },
    resolver: yupResolver(schema)
  })
  const [authError, setAuthError] = useState<string>('')

  const onSubmit = async (data: IForgotPwdForm): Promise<void> => {
    try {
      await Auth.forgotPassword(data.email)
      navigate(ROUTES_PATH.FORGOT_PASSWORD_RESET, {
        state: { email: data.email }
      })
    } catch (error) {
      if (error instanceof Error) {
        setAuthError(error.message)
      }
    }
  }

  return (
    <form method="post" onSubmit={handleSubmit(onSubmit)}>
      <Box my={2}>
        <FormLabel>EMAIL ADDRESS</FormLabel>
        <Controller
          name="email"
          control={control}
          render={({ field: { onChange, value, name } }): JSX.Element => (
            <OutlinedInput
              name={name}
              placeholder="Enter your email address"
              onChange={onChange}
              value={value}
              type="text"
              fullWidth
            />
          )}
        />
        {errors.email && <ErrorText>{errors.email.message}</ErrorText>}
        {authError && <ErrorText>{authError}</ErrorText>}
      </Box>

      <Box mt={3} textAlign="center">
        <MButton
          variant="contained"
          type="submit"
          size="large"
          rounded="true"
          disabled={!isValid}
          sx={{ width: '200px', marginTop: '10px', marginBottom: '10px' }}
        >
          Next
        </MButton>
      </Box>

      <BackToLogin />
    </form>
  )
}
